import React from "react";
import styled from "styled-components";

interface DashBoardToggleBtnProps {
  btnTextArray: string[];
  filter: {
    startDate: string;
    endDate: string;
    isAccum: boolean;
  };
  setFilter: any;
  clickEvent?: () => void;
}

interface SDashBoardToggleBtnItem {
  isActive?: boolean;
}

export default function DashBoardToggleBtn({
  btnTextArray,
  filter,
  setFilter,
  clickEvent,
}: DashBoardToggleBtnProps) {
  const cllickEvent = (name: string) => {
    setFilter({
      ...filter,
      isAccum: btnTextArray[1] === name,
    });

    if (clickEvent) {
      clickEvent();
    }
  };

  return (
    <DashBoardToggleBtnContainer>
      {btnTextArray?.map((t, i) => (
        <DashBoardToggleBtnItem
          onClick={() => cllickEvent(t)}
          key={i}
          isActive={btnTextArray[1] === t ? filter.isAccum : !filter.isAccum}
        >
          <DashBoardToggleBtnItemText
            isActive={btnTextArray[1] === t ? filter.isAccum : !filter.isAccum}
          >
            {t}
          </DashBoardToggleBtnItemText>
        </DashBoardToggleBtnItem>
      ))}
    </DashBoardToggleBtnContainer>
  );
}

const DashBoardToggleBtnContainer = styled.div`
  display: flex;
  align-items: center;
`;

const DashBoardToggleBtnItem = styled.button<SDashBoardToggleBtnItem>`
  padding: 0 16px;
  height: 32px;
  border: solid 1px
    ${({ theme, isActive }) =>
      isActive ? "#00beb0" : theme.buttonColor.lineNormal};
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;

const DashBoardToggleBtnItemText = styled.span<SDashBoardToggleBtnItem>`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme, isActive }) =>
    isActive ? "#00beb0" : theme.color.gray600};
`;
